import script from "./VIPItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VIPItem.vue?vue&type=script&setup=true&lang=ts"

import "./VIPItem.vue?vue&type=style&index=0&id=c00b763a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00b763a"]])

export default __exports__